var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"two-dots",style:(_vm.getStyles)},[_c('div',{staticClass:"dot1"}),_c('div',{staticClass:"dot2"})])
}
var staticRenderFns = []

export { render, staticRenderFns }